export const navbarHeight = 80;
export const footerHeight = 55;
export const sidebarWidth = 298;
export const postWidth = 680;
